// pages/QuestionnaireMedicalSkincare.tsx
import React from 'react';
import QuestionnaireForm from '../components/QuestionnaireForm';

/**
 * 医疗级护肤问诊票页面
 */
const QuestionnaireMedicalSkincare: React.FC = () => {
  return (
    <QuestionnaireForm 
      questionFile="skincare_questions.json" 
      service="skincare" 
    />
  );
};

export default QuestionnaireMedicalSkincare;
